import {
  Box,
  Flex,
  Image,
  Link,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorModeValue,
  Stack,
  useColorMode,
} from '@chakra-ui/react';
import { HamburgerIcon, MoonIcon, SunIcon } from '@chakra-ui/icons';
import logo from '../../assets/img/logo.svg';

const NavLink = ({ children }) => (
  <Link
    focusBorderColor="rgba(39, 72, 77,0.5)"
    px={2}
    py={1}
    rounded={'md'}
    _hover={{
      textDecoration: 'none',
      bg: useColorModeValue('gray.100', 'gray.700'),
    }}
    href={'/'}
  >
    {children}
  </Link>
);

export default function Nav() {
  const { colorMode, toggleColorMode } = useColorMode();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const bg = useColorModeValue('gray.200', 'black');
  const color = useColorModeValue('gray.700', '#9ad8e0');
  return (
    <>
      <Box bg={bg} color={color} px={4}>
        <Flex h={20} alignItems={'center'} justifyContent={'space-between'}>
          <NavLink>
            <Image src={logo} alt="irina" boxSize="4rem" />
          </NavLink>

          <Flex alignItems={'center'}>
            <Stack direction={'row'} spacing={7}>
              <Button onClick={toggleColorMode}>
                {colorMode === 'dark' ? <SunIcon /> : <MoonIcon />}
              </Button>

              <Menu>
                <MenuButton
                  as={Button}
                  rounded={'full'}
                  variant={'link'}
                  cursor={'pointer'}
                  minW={0}
                >
                  <HamburgerIcon />
                </MenuButton>
                <MenuList alignItems={'center'}>
                  {/* <MenuItem>Skills</MenuItem> */}
                  <Link
                    href="/projects"
                    _hover={{
                      textDecoration: 'none',
                    }}
                  >
                    {' '}
                    <MenuItem>Projects</MenuItem>{' '}
                  </Link>
                  <Link
                    href="/contact"
                    _hover={{
                      textDecoration: 'none',
                    }}
                  >
                    <MenuItem>Contact</MenuItem>
                  </Link>
                </MenuList>
              </Menu>
            </Stack>
          </Flex>
        </Flex>
      </Box>
    </>
  );
}
